// extracted by mini-css-extract-plugin
export var avatarContainer = "_b7-0";
export var avatarTypingWave = "_b7-i";
export var gray = "_b7-f";
export var green = "_b7-c";
export var icon = "_b7-9";
export var image = "_b7-1";
export var lg = "_b7-6";
export var md = "_b7-5";
export var presenceDot = "_b7-b";
export var red = "_b7-d";
export var sm = "_b7-4";
export var status = "_b7-a";
export var typingDot = "_b7-h";
export var typingPill = "_b7-g";
export var xl = "_b7-7";
export var xs = "_b7-3";
export var xxl = "_b7-8";
export var xxs = "_b7-2";
export var yellow = "_b7-e";